/**
 * 导出excel接口
 */
export default {
  BASE_URL: '',
  api: [
    {
      name: 'orderPrintExcel',
      desc: '打印审批表Excel',
      method: 'POST',
      path: '/tm/order/printExcel'
    },
    {
      name: 'orderPricePrintExcel',
      desc: '销售报价单Excel',
      method: 'POST',
      path: '/tmb/order/printExcel'
    },
    {
      name: 'printPurchaseExcel',
      desc: '打印采购订单Excel',
      method: 'POST',
      path: '/tmb/order/printPurchaseExcel'
    },
    {
      name: 'receiptSupplierPrintExcel',
      desc: '打印送货单Excel',
      method: 'POST',
      path: '/tm/order/receipt/printReceiptExcel'
    },
    {
      name: 'statementPurchasePrintExcel',
      desc: '打印采购对账单Excel',
      method: 'POST',
      path: '/cb/statement/purchase/printExcel'
    },
    {
      name: 'statementOrderPrintExcel',
      desc: '打印销售对账单Excel',
      method: 'POST',
      path: '/cb/statement/order/printExcel'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/print.js